const skipFeatures = [
  'overnightGuests',
  'outsideArea',
  'smokingAllowed',
  'checkedBySpotahome',
  'petsAllowed',
  'couplesAllowed'
];

const featuresLocoKeys = {
  furnished: { key: 'Furnished' },
  airConditioner: {
    key: 'A/C',
    options: {
      individualUnits: 'Available',
      central: 'Available',
      notAvailable: 'Not available'
    }
  },
  elevator: { key: 'Elevator' },
  equippedKitchen: { key: 'Equipped kitchen' },
  balconyOrTerrace: { key: 'Balcony or terrace' },
  roomType: {
    key: 'Room',
    options: {
      singleBed: 'Single Bed',
      doubleBed: 'Double Bed',
      twinsBed: 'Twin Beds',
      bunkbed: 'Bunk Beds',
      '2singleBeds': 'Single Bed',
      '3singleBeds': '3 beds or more',
      '4singleBeds': '3 beds or more',
      '2doubleBeds': 'Double Bed'
    }
  },
  heatingUnit: { key: 'Heating unit' },
  privateBath: { key: 'Private bath (en-suite)' },
  desk: { key: 'Desk' },
  tv: { key: 'TV' },
  interiorExterior: {
    key: 'Interior',
    keys: {
      interior: 'Interior',
      exterior: 'Exterior'
    },
    options: {
      interior: 'structured.data.positive.note.interior',
      exterior: 'structured.data.positive.note.exterior'
    }
  },
  chestDrawers: { key: 'Chest of Drawers' },
  shelving: { key: 'shelving' },
  doormanReception: { key: 'Doorman/Reception' },
  poolAccess: { key: 'Pool access' },
  parkingAvailable: { key: 'Parking available' },
  washingMachine: {
    key: 'Washing machine',
    options: {
      notAvailable: 'Not available',
      private: 'Available',
      common: 'Available'
    }
  },
  dryer: {
    key: 'Dryer',
    options: {
      notAvailable: 'Not available',
      private: 'Available',
      common: 'Available'
    }
  },
  dishwasher: { key: 'Dishwasher' },
  oven: { key: 'Oven' },
  handicapAccessible: { key: 'Handicap accessible' },
  heatedWaterSystem: {
    key: 'Water',
    options: {
      notAvailable: 'Not available',
      naturalGas: 'Natural gas heating',
      bottleGas: 'Bottled gas water heating',
      electric: 'Electric water heating',
      centralBuilding: 'Central water heating',
      centralProperty: 'Central water heating'
    }
  },
  heatingSystem: {
    key: 'Heating',
    options: {
      notAvailable: 'Not available',
      centralProperty: 'Whole house electric heating',
      centralBuilding: 'Central heating',
      underfloor: 'Other heating system',
      bottledGas: 'Bottled gas water heating',
      singleElectric: 'Electric water heating',
      electricWhole: 'Electric water heating',
      naturalGas: 'Natural gas water heating',
      airConditioner: 'AC units for heating',
      other: 'Other heating system'
    }
  },
  clothesDryer: {
    key: 'Clothes dryer',
    options: {
      notAvailable: 'Not available',
      dryer: 'Clothes dryer',
      individualRackInside: 'Drying rack',
      individualRackTerraceBalcony: 'Drying rack',
      stringsBackyard: 'Clotheslines'
    }
  },
  storage: { key: 'Storage' },
  independentKey: { key: 'Independent key' },
  wardrobeType: {
    key: 'Shelving',
    options: {
      notAvailable: 'Not available',
      builtIn: 'Built-in wardrobe',
      standalone: 'Standalone wardrobe'
    }
  },
  window: {
    key: 'Window',
    options: {
      notAvailable: 'Not available',
      yesNoView: 'Window',
      interiorLightWell: 'Window view courtyard',
      streetView: 'Window view street',
      pedestrianStreetView: 'Window view pedestrian street',
      courtyardView: 'Window view courtyard',
      interiorPatioView: 'Window view interior patio'
    }
  }
};

const generateListItemValue = (entry, key, value, trans) => {
  const translationKey = `structured.data.positive.note.${key}`;
  const customTranslation = trans(translationKey, { value });

  if (entry.options) {
    return trans(entry.options[value]);
  }
  if (value === 'yes' && customTranslation !== translationKey) {
    return customTranslation;
  }
  if (value === 'yes' && customTranslation === translationKey) {
    return trans('Available');
  }
  return trans('Not available');
};

const transListItemName = (featureKey, featureValue, trans) => {
  if (
    featuresLocoKeys[featureKey].keys &&
    featuresLocoKeys[featureKey].keys[featureValue]
  ) {
    return trans(featuresLocoKeys[featureKey].keys[featureValue]);
  }

  return trans(featuresLocoKeys[featureKey].key);
};

export const generatePositiveNotes = (propertyFeatures, trans) => {
  return Object.entries(propertyFeatures)
    .filter(([key, value]) => {
      return (
        (value.category === 'features' || value.category === 'extraFeatures') &&
        !skipFeatures.includes(key)
      );
    })
    .map(([key, value], i) => {
      return {
        '@type': 'ListItem',
        position: i + 1,
        name: transListItemName(key, value.value, trans),
        description: generateListItemValue(
          featuresLocoKeys[key],
          key,
          value.value,
          trans
        )
      };
    });
};
